import * as React from 'react';

const PageNotFound = () => (
  <div className="text-center f1 p-10">Siden blev ikke fundet</div>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/Pages/PageNotFound.tsx